import React, { useState, useRef, useEffect } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import LazyLoader from "./LazyLoader";
import { getFAQ } from "../api/api";

function Explore() {
    const [activeIndex, setActiveIndex] = useState(1);
    const [isVisible, setIsVisible] = useState(false);
    const [faqs, setFaqs] = useState([]);
    const [error, setError] = useState(null);

    const sectionRef = useRef(null);

    const toggleAccordion = (index) => {
        setActiveIndex(index === activeIndex ? activeIndex : index);
    };

    useEffect(() => {
        const fetchFAQs = async () => {
            try {
                const response = await getFAQ();
                if (response.status) {
                    setFaqs(response.data);
                } else {
                    setError(response.message);
                }
            } catch (error) {
                console.error("Error fetching FAQs:", error);
                setError("Failed to fetch FAQs");
            }
        };

        fetchFAQs();
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div className="pt-80 pb-80">
            <div
                ref={sectionRef}
                className={`custom-padding xl-screen-padding explore-screen ${isVisible ? "animate-slide-in" : ""}`}
            >
                <div className="flex flex-col xl:flex-row justify-between items-start">
                    <div className={`image flex justify-center xl:w-1/2 ${isVisible ? "slide-left" : ""}`}>
                        <LazyLoader
                            src={require("../../src/assets/images/Infographicnew.webp")}
                            alt="Gut-brain Axis"
                            placeholder="#f0f0f0"
                            className="rounded-sm p-0 sm:p-2 md:p-2"
                        />
                    </div>

                    <div className={`text pl-0 sm:pl-8 md:pl-8 xl:pl-8 xl:w-1/2 ${isVisible ? "slide-right" : ""}`}>
                        <h2 className="text-h2 client-text font-bold mb-5 text-[#2b343b]">
                            How It Works
                        </h2>
                        {error ? (
                            <div className="text-red-500">{error}</div>
                        ) : (
                            <div className="space-y-4">
                                {faqs.map((faq, index) => (
                                    <div
                                        key={faq.id}
                                        className="border border-gray-300 rounded-lg overflow-hidden cs_accordians transform transition-all duration-300 hover:shadow-md hover:border-gray-400"
                                        onClick={() => toggleAccordion(index + 1)}
                                    >
                                        <div
                                            style={{
                                                background: activeIndex === index + 1
                                                    ? "linear-gradient(119deg,#bd992e 17.16%, #9a7710 89.78%)"
                                                    : "white",
                                                color: activeIndex === index + 1 ? "white" : "#191919"
                                            }}
                                            className="cs_accordians client-text font-semibold px-4 py-3 flex justify-between items-center cursor-pointer"
                                        >
                                            <span
                                                style={{
                                                    color: activeIndex === index + 1 ? "white" : "#191919"
                                                }}
                                            >
                                                {faq.title}
                                            </span>
                                            {activeIndex === index + 1 ? <FaChevronUp /> : <FaChevronDown />}
                                        </div>
                                        {activeIndex === index + 1 && (
                                            <div
                                                className="bg-gray-100 px-4 py-3 text-[#000000] text-p"
                                                dangerouslySetInnerHTML={{ __html: faq.description.replace(/<p>/g, "").replace(/<\/p>/g, "") }}
                                            />
                                        )}

                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Explore;